import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/closed`;

interface ForceCloseFilesCommandArgs {
  fileIds: string[];
  comment?: string;
  toCustomerComment?: string;
  closing?: string;
}

const forceCloseFilesCommand = async ({
  fileIds,
  comment,
  toCustomerComment,
  closing,
}: ForceCloseFilesCommandArgs): Promise<
  BaseBackResponse | BackResponseFailure
> => {
  try {
    return await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: { fileIds, comment, toCustomerComment, closing },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default forceCloseFilesCommand;
